import { submit } from 'e-submission/domain/data-model/form/pages/submit'
import { isAuraSupport, isSelectedRemoteSelling } from 'e-submission/domain/data-model/form/selectors'
import { appendBefore, concatWith, createPageCreator } from 'e-submission/domain/data-model/form/utils'
import investmentBaseForm from 'e-submission/domain/data-model/product-form/product-investment/base'
import { insuredHealth, payerHealth } from 'e-submission/domain/data-model/form/pages/health'

import { compact, flow } from 'lodash/fp'
import { getToggles } from 'quick-quote/feature-toggles'
import { signature } from '../signature'
import submitApplicationSection from './submitSection'

export default (app) => {
  const createPage = createPageCreator(app)
  const isShowAura = getToggles().ALLOW_AURA_QUESTIONARE && isAuraSupport(app)

  return flow(
    investmentBaseForm(createPage, false),
    concatWith([
      createPage(signature(app)),
      createPage(
        submit({
          sections: [submitApplicationSection('submit-application')],
        })
      ),
    ]),
    isShowAura
      ? (app) => app
      : appendBefore(null, 'FATCA', [createPage(insuredHealth(app)), createPage(payerHealth(app))]),
    compact
  )(app)
}
